export class SiteChart {
  siteCustomerName: any;
  branch: string;
  s1Label: string;
  s1qtyUnfilled: any;
  s1qtyFilled: any;
  s2Label: string;
  s2qtyUnfilled: any;
  s2qtyFilled: any;
  s3Label: string;
  s3qtyUnfilled: any;
  s3qtyFilled: any;
  s4Label: string;
  s4qtyUnfilled: any;
  s4qtyFilled: any;
  s5Label: string;
  s5qtyUnfilled: any;
  s5qtyFilled: any;
  s6Label: string;
  s6qtyUnfilled: any;
  s6qtyFilled: any;
  total: any;
  filled: any;
  site: number;
}
